import { V4 } from '@moleculeone/utils';

import { atomToNeighborsPairs } from './selectors';

export default class Bending {
  constructor(factor) {
    this.factor = factor;
  }

  apply(mol, forces) {
    const neighbors = atomToNeighborsPairs(mol);
    for (const akey of Object.keys(mol.atoms)) {
      const nlist = neighbors[akey];
      if (nlist.length < 2) {
        continue;
      }

      const zeroVect = V4.vect(0, 1);
      const centerPos = mol.positions[akey];
      const rayData = [];
      const angles = {};
      for (let i = 0; i < nlist.length; i++) {
        const [nbond, natom] = nlist[i];
        const vector = V4.sub(mol.positions[natom.idx], centerPos);
        angles[natom.idx] = V4.angleZ(vector, zeroVect);
        rayData.push([nbond, natom, vector]);
      }
      rayData.sort(([, a], [, b]) => angles[a.idx] - angles[b.idx]);
      rayData.push(rayData[0]);

      for (let i = 0; i < rayData.length - 1; i++) {
        const [startBond, startAtom, startVect] = rayData[i];
        const [endBond, endAtom, endVect] = rayData[i + 1];

        const angle = V4.angleZ(endVect, startVect);

        let descent;
        if (nlist.length === 2 && startBond.order + endBond.order === 4) {
          descent = Math.sin(angle);
        } else if (nlist.length < 4) {
          descent = Math.sin(angle) + Math.sin(2 * angle);
        } else {
          descent = -Math.sin(nlist.length * angle);
        }

        const iforce = V4.normal(V4.rotZ(startVect, -Math.PI / 2.0), this.factor * descent);
        const jforce = V4.normal(V4.rotZ(endVect, Math.PI / 2.0), this.factor * descent);

        forces[startAtom.idx].push(iforce);
        forces[endAtom.idx].push(jforce);
        forces[akey].push(V4.scale(iforce, -1));
        forces[akey].push(V4.scale(jforce, -1));
      }
    }
  }
}
